import { type QueryHookOptions, QueryResult } from "@apollo/client/react/types/types";
import { FIND_MEMBER_QUERY } from "../Queries";
import { useQuery } from "@apollo/client";
import { Member } from "../generated/graphql";
import { AuthContextProps } from "oidc-react";

export function useMember(policyId?: string, memberId?: string, effectiveDate?: string, auth?: AuthContextProps, options?: QueryHookOptions): QueryResult<{ findMember: Member | null }> {
    const user = auth?.userData;
    const signedIn = !!user;
    return useQuery(FIND_MEMBER_QUERY, {
        variables: {
            policyId,
            memberId,
            effectiveDate
        },
        skip: !signedIn || policyId?.length !== 7 || memberId?.length !== 9,
        ...options
    })
}